import { IComboBoxStyles, IDropdownStyles } from "@fluentui/react";

const mainColor = "#cc214F"

export const dropdownStylesMultiple: Partial<IDropdownStyles> = {
    caretDown:
    {
        color: mainColor,
        fontSize: "14px",
        fontWeight: 700,
    },
    dropdownItems:
    {
        color: "white",
        borderColor: "transparent",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px",
    },
    title:
    {
        color: `${mainColor} !important`,
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        backgroundColor: "white !important",
    },
    dropdownOptionText: { color: mainColor, }
};

export const dropdownStylesMultipleIndices: Partial<IComboBoxStyles> = {
    // caretDown:
    // {
    //     color: mainColor,
    //     fontSize: "14px",
    //     fontWeight: 700,
    // },
    // dropdownItems:
    // {
    //     color: "white",
    //     borderColor: "transparent !important",
    //     fontWeight: 500,
    //     fontSize: "20px",
    // },
    // title:
    // {
    //     backgroundColor: "transparent !important",
    //     color: `${mainColor} !important`,
    //     borderColor: "transparent !important",
    //     fontWeight: 500,
    //     fontSize: "20px",
    //     borderRadius: '50px !important'
    // },
    // dropdownItem: {
    //     border: "none"
    // },
    // dropdownItemSelected:
    // {
    //     backgroundColor: "transparent !important",
    //     borderColor: "transparent !important",
    // },
    // dropdownOptionText: { color: "black",  },
    callout: {
        maxHeight: '500px', 
        overflowY: 'auto',
    },
    root: {
        border: "none !important",
    },
};


export const dropdownStylesSingle: Partial<IDropdownStyles> = {
    caretDown:
    {
        color: mainColor,
        fontSize: "14px",
        fontWeight: 700,
    },
    dropdownItems:
    {
        color: "white",
        borderColor: "transparent",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px",
    },
    title:
    {
        color: `${mainColor} !important`,
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        backgroundColor: mainColor,
    },
    dropdownOptionText: { color: mainColor, }
};